module.exports = __webpack_public_path__ + "static/media/warning.ddf5a5b8.svg";